import { Tile } from '@carbon/react';
import styles from './unit-details-ribbon.module.scss';
import { Field } from './Field';
import { capitalize } from 'lodash-es';
import { format2, formatNumber } from '../../../utils/number';

interface UnitDetailsProps {
  name: string;
  allocationMethod: string;
  basin: string;
  tier: string;
  grossAcres: number;
  tractLength: number;
  tractWidth: number;
  isPlatBased: boolean;
  unitType: string;
  currentOperator?: string;
  state: string;
  ltdCapable: boolean;
}

export const UnitDetailsRibbon = ({
  name,
  state,
  allocationMethod,
  basin,
  tier,
  grossAcres,
  tractLength,
  tractWidth,
  isPlatBased,
  unitType,
  currentOperator,
  ltdCapable,
}: UnitDetailsProps) => {
  const allocationMethodFormatted = allocationMethod
    ? allocationMethod.split('_').map(capitalize).join(' ')
    : '--';

  return (
    <Tile className={styles.unitDetailsRibbon}>
      <div className={styles.titleSection}>Unit Details</div>
      <div className={styles.detailsSection}>
        <Field label="Name" value={name} />
        <Field label="Current Operator" value={currentOperator} />
        <Field label="Unit Type" value={capitalize(unitType)} />
        {/* TODO: Update Unit Type when backend is set up */}
        <Field label="Allocation Method" value={allocationMethodFormatted} />
        <Field label="LTD Capable" value={ltdCapable ? 'Yes' : 'No'} />
        <Field label="State" value={state} />
        <Field label="Basin" value={basin} />
        <Field label="Tier" value={tier} />
        <Field label="Plat Based" value={isPlatBased ? 'Yes' : 'No'} />
        <Field label="Gross Acres (GIS)" value={format2(grossAcres)} />
        <Field
          label="Unit Tract Length (GIS)"
          value={formatNumber({
            value: tractLength,
            minPrecision: 0,
            maxPrecision: 0,
            includeCommas: true,
            unit: 'ft',
          })}
        />
        <Field
          label="Unit Tract Width (GIS)"
          value={formatNumber({
            value: tractWidth,
            minPrecision: 0,
            maxPrecision: 0,
            includeCommas: true,
            unit: 'ft',
          })}
        />
      </div>
    </Tile>
  );
};
